<template>
    <Paper :header="$t('spotlight.contactDetails.header')" tall>
        <ContactDetailsSkeleton v-if="isLoading" />
        <div v-else class="p-4">
            <h6 class="subtitle bold">
                {{ $t('spotlight.contactDetails.contactEmail') }}
            </h6>
            <TextField
                class="mb-1"
                :class="{ 'mb-4': Boolean(oldUserData.email) || !value.email }"
                type="email"
                autocomplete="email"
                :value="value.email"
                @input="handleEmailChange"
                :disabled="Boolean(oldUserData.email)"
                :placeholder="$t('spotlight.contactDetails.contactEmail')"
                :stateEnum="
                    oldUserData.email
                        ? StateEnum.SUCCESS
                        : Boolean(emailErrorMessage && value.email)
                        ? StateEnum.ERROR
                        : -1
                "
                @blur="validateEmail"
                :error="Boolean(emailErrorMessage && value.email)"
                :helperText="value.email ? emailErrorMessage : null"
            />
            <h6
                v-if="!Boolean(oldUserData.email) && value.email"
                class="caption mute mb-4 error-color"
                style="font-size:12px;"
            >
                {{ $t('spotlight.contactDetails.permanentEmail') }}
            </h6>

            <h6 class="subtitle bold">
                {{ $t('spotlight.contactDetails.phoneNumberHeader') }}
            </h6>
            <div class="d-flex align-items-center">
                <BaseSearchable
                    class="countryCodeInput mr-2 h-100"
                    autocomplete="tel-country-code"
                    :data="countryCodes"
                    :value="countryCode"
                    prefix="+"
                    @input="handleCountryCodeChange"
                    :placeholder="$t('spotlight.contactDetails.countryCode')"
                />
                <TextField
                    class="w-100"
                    type="number"
                    :value="phoneNumber"
                    @input="handlePhoneNumberChange"
                    :placeholder="$t('spotlight.contactDetails.phoneNumber')"
                />
            </div>
        </div>
    </Paper>
</template>

<script>
// Data and util imports
import codes from '~/data/codes';
import StateEnum from '~/utils/StateEnum';
import splitFullPhoneNumber from '~/utils/splitFullPhoneNumber';
import { emailValidator } from '~/utils/validators';

// Components
import ContactDetailsSkeleton from '../skeletons/ContactDetailsSkeleton';

export default {
    name: 'ContactDetails',
    components: { ContactDetailsSkeleton },
    props: {
        value: {
            type: Object,
            default: () => ({}),
            required: true,
        },
        oldUserData: {
            type: Object,
            default: () => ({}),
            required: true,
        },
        isLoading: Boolean,
    },
    data: () => ({
        countryCodes: codes,
        countryCode: null,
        phoneNumber: '',
        StateEnum: StateEnum,

        emailErrorMessage: null,
    }),
    methods: {
        handleCountryCodeChange(newVal) {
            this.countryCode = newVal;
            this.emitValue();
        },
        handlePhoneNumberChange(newVal) {
            this.phoneNumber = newVal;
            this.emitValue();
        },
        countryCodeToString(code) {
            return code ? '+'.concat(code.label, ' ') : '';
        },
        emitValue() {
            this.$emit('input', {
                ...this.value,
                phoneNumber: this.countryCodeToString(this.countryCode).concat(
                    this.phoneNumber
                ),
            });
        },
        splitFullPhoneNumber(fullPhoneNumber) {
            const phoneNumbInfo = splitFullPhoneNumber(
                fullPhoneNumber,
                this.countryCodes
            );
            this.countryCode = phoneNumbInfo.code;
            this.phoneNumber = phoneNumbInfo.phoneNumber;
        },
        handleEmailChange(email) {
            this.emailErrorMessage = null;
            const user = Object.assign({}, this.value);
            user.email = email;
            this.$emit('input', user);
        },
        isValidEmail() {
            return emailValidator(this.value.email);
        },
        validateEmail() {
            if (!this.isValidEmail()) {
                this.emailErrorMessage = this.$t(
                    'spotlight.contactDetails.invalidEmail'
                );
            }
        },
    },
    mounted() {
        this.splitFullPhoneNumber((this.value || {}).phoneNumber);
    },
    watch: {
        value(newVal) {
            this.splitFullPhoneNumber(newVal.phoneNumber);
        },
    },
};
</script>

<style scoped>
.countryCodeInput {
    width: 50%;
}

@media only screen and (max-width: 600px) {
    .countryCodeInput {
        width: 220px;
    }
}
</style>
